import React, { useEffect, useRef, useState, FC } from "react";
import { Button, message } from "antd";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { usePurchaseRoDetailsModel } from "./purchaseRoDetailsModel"
import { DetailType } from "@/types/ScmEnums";
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { useDictModel } from "../../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
interface ITopType {
    id: string,
    mode: "add" | "edit" | "look",
    purchasePoDetails: React.MutableRefObject<IYhFormRef | undefined>
}
export const FormBox: FC<ITopType> = ({ id, mode, purchasePoDetails }) => {
    const { detailLookForm, detailAddForm, detailEditForm, getDetailEditOne, resetAddCatch, resetEditCatch, updateAddFormVal, updatEditFormVal } = usePurchaseRoDetailsModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName } = useDictModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale, supplieAllList } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    useEffect(() => {
        if (!Object.keys(detailEditForm).length && mode == DetailType.edit) {
            getDetailEditOne(id, mode)
        }
        mode == DetailType.look && getDetailEditOne(id, mode)
    }, [id, mode])
    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav("3-2-1") && resetAddCatch(mode)
            !findNav("3-2-2") && resetEditCatch(mode);
            // !findNav("3-2-3") && resetCatch(mode);
        }
    }, [selectedNavId])
    const baseFormItem: IYhFormItemsBox = {
        // title: "基础信息",
        title: Locale["Basic Info"],
        style: { padding: "18px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-77",
        items: [
            {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "供应商名称",
                fieldLabel: Locale["Supplier Name"],
                fieldName: "supplierCode",
                showSearch: true,
                options: transOptions(supplieAllList),
                rules: [{ required: true, message: "请选择供应商" }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系人",
                fieldLabel: Locale["Contact"],
                fieldName: "contact",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "制单时间",
                fieldLabel: Locale["Creation Time"],
                fieldName: "createTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "结算类型",
                fieldLabel: Locale["Payment Type"],
                fieldName: "payType",
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE),
                rules: [{ required: true, message: "请选择结算类型" }]        
            }, {
                type: FormItemTypeEnum.TreeSelect,
                // fieldLabel: "供应商类型",
                fieldLabel: Locale["Supplier Type"],
                fieldName: "supplierTypeCode",
                treeData: getTreeSelectOne(DictCodeEnmu.SUPPLIER_TYPE),
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系电话",
                fieldLabel: Locale["Contact Number"],
                fieldName: "phone",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "备注",
                fieldLabel: Locale["Note"],
                fieldName: "note",
                span: 12,
                labelCol: { span: 3 },
            }
        ]
    };

    const onChange = (changedValues: { [key: string]: any }) => {
        if (mode == DetailType.add) {
            updateAddFormVal(changedValues)
        } else if (mode == DetailType.edit) {
            updatEditFormVal(changedValues)
        }
    }
    const typeForm = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm
    }
    const poFromConfig: IYhFormBox = {
        formRef: purchasePoDetails,
        labelCol: { span: 6 },
        labelAlign: "right",
        disabled: mode == DetailType.look,
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}